import './Footer.css'

const Footer = () => {
    return (
        <footer>Desarrollado por Pimba y Álvaro</footer>
    )
}

export default Footer